import { getIsMobile, getIsTablet } from '../../utils/ua'

const INITIAL_STATE = {
  isMobile: getIsMobile(),
  isTablet: getIsTablet(),
}

export function userDeviceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/userDevice/userDevice.reducers.js